module.exports = __webpack_public_path__ + "assets/img/qrcode-gzh-6c871c05.png";